module.exports = __webpack_public_path__ + "img/97.e66ded14.png";